<template>
    <div class="assort-view">
        <div class="side-view ">
            <div class="item" v-for="(item,index) in assortList" :key="index" @click='onNavClick(index)' ref="sideItem">
                {{item.text}}
            </div>
        </div>
        <div class="main-view">
            <div class="main-wrapper">
                <div class="goods-wrapper clearfix" v-for="(item,index) in goodsList" :key="index">
                    <div class="img">
                        <img :src="item.img" alt="">
                        <!-- 垂直居中 -->
                        <span></span>
                    </div>
                    <div class="content">
                        <p class="name">{{item.name}}</p>
                        <p class="old-price">原價：${{item.oldPrice}}</p>
                        <p class="price">折扣價：${{item.price}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "assortView",
        data() {
            return {
                title: "分類",
                navViewShow: true,
                assortList: null,
                activeIndex: 0,
                selectItem: null,
                goodsList: null
            };
        },
        methods: {
            onNavClick: function (index) {
                this.activeIndex = index
                this.goodsList = this.assortList[index].children
                //先移除原先樣式
                this.selectItem.className = 'item'
                //當前
                this.selectItem = this.$refs.sideItem[this.activeIndex]
                //添加樣式
                this.selectItem.className += ' active'
            }
        },
        created() {
            // console.log(this.title);
            // 創建時，發送標題
            this.$emit("onTitle", this.title);
            this.$emit("onNavShow", this.navViewShow);
            var that = this;
            this.$ajax.get('/json/assort.json')
                .then(function (response) {
                    console.log(response.data);
                    that.assortList = response.data;
                    that.$nextTick(function () {
                        that.goodsList = that.assortList[that.activeIndex].children
                        //默認選中
                        this.selectItem = this.$refs.sideItem[that.activeIndex]
                        that.selectItem.className = 'item active'
                    })
                })
        }
    };

</script>

<style lang="scss">
    .assort-view {
        .clearfix {
            clear: both;
        }
        width: 100%;
        background-color: #f2f2f2;
        margin-bottom: 50px;
        padding: 45px 50px 0 0;
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        .side-view {
            height: 100%;
            width: 25%;
            background-color: white;
            float: left;
            padding: 15px;
            .item {
                font-size: 12px;
                line-height: 26px;
                height: 26px;
                border-radius: 12px;
                text-align: center;
                color: black;
            }
            .active {
                background-color: black;
                color: white;
            }
        }
        .main-view {
            height: 100%;
            width: 60%;
            float: left;
            margin: 3%;
            overflow: auto;
            .main-wrapper {
                width: 100%;
                padding-bottom: 10px;
                .goods-wrapper {
                    background-color: white;
                    height: 100px;
                    width: 100%;
                    margin-bottom: 10px;
                    padding: 10px;
                    box-sizing: border-box;
                    border-radius: 5px;
                    .img {
                        width: 33%;
                        float: left;
                        height: 100%;
                        img {
                            width: 100%;
                            vertical-align: middle;
                        }
                        span {
                            vertical-align: middle;
                            display: inline-block;
                            height: 100%;
                        }
                    }
                    .content {
                        width: 67%;
                        float: left;
                        .name {
                            font-size: 12px;
                            line-height: 17px;
                        }
                        .old-price {
                            font-size: 12px;
                            line-height: 33px;
                            text-decoration: line-through;
                        }
                        .price {
                            font-size: 12px;
                            color: red;
                        }
                    }
                }
            }
        }
    }
</style>
